import RequestsDistributeDetailEdit from './RequestsDistributeDetailEdit';
import { COPY } from 'constants/constants';

const RequestsCopyDetailEdit = () => {
  return <RequestsDistributeDetailEdit action={COPY} />;
};

export default RequestsCopyDetailEdit;
